"use client";

import { useTranslations } from "next-intl";
import cx from "classnames";

// Components
import Image from "next/image";
import IconSprite from "@/components/UI/IconSprite";

// Utils
import st from "./index.module.scss";
import { PUBLIC_IMAGE_URL } from "@/network/http-config";
import { GameType } from "@/domains/games/types";
import { useStore } from "@/hooks/use-store";
import AuthModal from "@/components/Modal/Auth/AuthModal";
import ModalGameMobileInit from "@/domains/games/components/game-mobile-init-modal";

type ModalGameMobileViewProps = {
  item: GameType;
  onClose?: () => void;
};

export default function ModalGameMobileView({ item, onClose }: ModalGameMobileViewProps) {
  const t = useTranslations("GamePage");
  const tGames = useTranslations("GamesPage");
  const { user, modal, modalSheet } = useStore();

  const filterTags = [
    {
      id: 1,
      label: "filter.play&go",
    },
    {
      id: 2,
      label: "filter.popular",
    },
    {
      id: 3,
      label: "filter.slots",
    },
    {
      id: 4,
      label: "filter.forMen",
    },
  ];

  const handleClose = (event: React.FormEvent, isDemo: boolean) => {
    onClose && onClose();
    event.preventDefault();

    if (!user.isAuth && !isDemo) {
      modal.showModal(<AuthModal activeTab={"login"} isLoggedIn={false} />);
    } else {
      modalSheet.closeMenu();

      setTimeout(() => {
        modal.showModal(<ModalGameMobileInit item={item} isDemo={isDemo} />);
      }, 150);
    }
  };

  return (
    <div className={st["games-info-wrap"]}>
      <div className={st["games-info"]}>
        <div
          className={st["games-info__header"]}
          style={{ backgroundImage: `url(${PUBLIC_IMAGE_URL}${item?.image})` }}
        >
          <button
            className={st["games-info__header-close"]}
            onClick={() => onClose?.()}
            aria-label="Close"
          >
            <IconSprite name="close" className={st["games-info__header-close-icon"]} />
          </button>
          <div className={st["games-info__header-img-wrap"]}>
            <Image
              className={st["games-info__header-img"]}
              src={`${PUBLIC_IMAGE_URL}${item?.image}`}
              alt={item?.name}
              width={265}
              height={329}
              loading="lazy"
            />
          </div>
        </div>
        <div className={st["games-info__body"]}>
          <div>
            <div className={st["games-info__body-name"]}>
              <div className={st["games-info__body-name-provider"]}>{item.provider.name}</div>
              <div className={st["games-info__body-name-title"]}>{item.name}</div>
            </div>
            <div className={st["games-info__body-button-wrap"]}>
              <button
                className={cx("btn", "btn--secondary", st["games-info__body-button"])}
                onClick={(e) => handleClose(e, true)}
              >
                {t("demo")}
              </button>
              <button
                className={cx("btn", st["games-info__body-button"])}
                onClick={(e) => handleClose(e, false)}
              >
                {t("play")}
              </button>
            </div>
            <div className={st["games-info__body-realmoney"]}>
              <div className={st["games-info__body-realmoney-title"]}>{t("realMoney")}</div>
              <div className={st["games-info__body-realmoney-subtitle"]}>{t("realMoneyText")}</div>
            </div>
          </div>
          <div className={st["games-info__body-tags-wr"]}>
            <div className={st["games-info__body-tags"]}>
              {filterTags.map((el) => (
                <a key={el.id} href="" className={st["games-info__body-tags-item"]}>
                  {tGames(el.label)}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
